import { z } from 'zod';
import { xml2ast, allHtmlParsers } from '@utils/ast';
import { knuthShuffle, expandSelfClosingTags } from '@utils/common';
import { baseTaskSchema } from '../schema.base.js';
import { twentyThreeAudioSchema } from '../schema.twenty-three-audio.js';
import { inTextDropzoneInput } from './input.dropzone.js';

const baseTileSchema = z.object({
  itemKey: z.string().default("")
});
const audioSchema = baseTileSchema.extend({
  type: z.literal("Audio"),
  title: z.string(),
  src: z.string().nullish().default(null),
  twentyThreeAudio: twentyThreeAudioSchema
}).transform(({
  twentyThreeAudio,
  ...rest
}) => ({
  ...rest,
  src: twentyThreeAudio?.src || rest.src || ""
}));
const imageSchema = baseTileSchema.extend({
  type: z.literal("Image"),
  title: z.string(),
  src: z.string(),
  audioSrc: z.string().nullable().default(null),
  altText: z.string().nullable().default(null),
  twentyThreeAudio: twentyThreeAudioSchema
}).transform(({
  twentyThreeAudio,
  ...rest
}) => ({
  ...rest,
  audioSrc: twentyThreeAudio?.src || rest.audioSrc
}));
const textSchema = baseTileSchema.extend({
  type: z.literal("Text"),
  text: z.string()
});
const placeItemsInTextTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("PlaceItems"),
  answerType: z.literal("InText"),
  items: z.array(z.discriminatedUnion("type", [audioSchema, imageSchema, textSchema])),
  text: z.string()
}).transform(({
  text,
  items,
  ...rest
}) => {
  const tiles = items.map((it, index) => ({
    ...it,
    id: `${rest.id}-${index}`,
    itemKey: it.itemKey || `${rest.id}-${index}`
  }));
  return {
    ...rest,
    __orderedTiles: tiles,
    tiles: knuthShuffle(structuredClone(tiles)),
    content: xml2ast(expandSelfClosingTags(text), {
      ...allHtmlParsers,
      ...inTextDropzoneInput.parsers
    }, "text/html", {
      context: {
        tiles,
        taskId: rest.id
      }
    })
  };
});

export { placeItemsInTextTaskSchema };
//# sourceMappingURL=_schema.js.map
